import { Pinia, Store } from 'pinia-class-component';
import { Contact, ContactsUiClient } from '../components/backend/backendapi';
import { initClient } from '../api';

@Store({
  id: 'ContactStore',
  name: 'ContactStore',
})
export default class ContactStore extends Pinia {
  private readonly contactApi = initClient(ContactsUiClient);

  //data
  private _loadingPromise: Promise<Contact[]> | null = null;
  private _contacts: Contact[] = [];

  //getter
  get loading(): boolean {
    return this._loadingPromise !== null;
  }

  get contacts(): Contact[] {
    return this._contacts;
  }

  get contactsById(): Map<string, Contact> {
    return new Map(this._contacts.map(c => [c.id, c]));
  }

  //actions
  clear(): void {
    this._contacts.splice(0);
  }

  setContacts(contacts: Contact[]): void {
    this._contacts.splice(0);
    this._contacts.push(...contacts);
  }

  rememberContact(contact: Contact): void {
    const index = this._contacts.findIndex(e => e.id == contact.id);
    if (index >= 0) {
      this._contacts.splice(index, 1, contact);
    } else {
      this._contacts.push(contact);
    }
  }

  forgetContact(contact: Contact): void {
    const index = this._contacts.findIndex(e => e.id == contact.id);
    if (index >= 0) {
      this._contacts.splice(index, 1);
    }
  }

  async reload(force: boolean = false): Promise<void> {
    if (this._loadingPromise) {
      await this._loadingPromise;
      if (!force) {// when force is true, wait for the current operation to complete, then reload
        return;
      }
    }

    try {
      this._loadingPromise = this.contactApi.list();
      const contacts = await this._loadingPromise;
      this.setContacts(contacts);
    } catch (err) {
      this.clear();
    } finally {
      this._loadingPromise = null;
    }
  }

  async loadIfAbsent(): Promise<void> {
    if (this._contacts.length > 0) {
      return;
    }
    return await this.reload();
  }
}